<template>
  <li class="list-item">
    <div class="list-item__header">
      <p class="list-item__heading">{{ item.name }}</p>
      <div v-if="editable">
        <v-btn icon color="pink" @click="handleDelete">
          <v-icon>
            icon-trash
          </v-icon>
        </v-btn>
        <v-btn icon color="primary" @click="handleEdit">
          <v-icon>
            icon-edit
          </v-icon>
        </v-btn>
      </div>
    </div>
    <div
      v-for="(hours, day) in filteredValues"
      class="list-item__day"
      :key="`${item.id}-${day}`"
    >
      <p class="mb-0">
        {{ $t(`message.weekDays.${WEEK_DAYS[upperFirst(day)]}`) }}
      </p>
      <ul v-if="hours.length > 0" class="pl-0">
        <li v-for="(hour, index) in hours" :key="`hours-${index}`">
          {{ formatOpeningHours(hour) }}
        </li>
      </ul>
    </div>
  </li>
</template>

<script>
import { pickBy, upperFirst } from "lodash";
import { WEEK_DAYS } from "@/enums/week-days";

export default {
  name: "MoreHoursCategoryListItem",
  data() {
    return {
      WEEK_DAYS
    };
  },
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    editable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    filteredValues() {
      return pickBy(this.item.values, val => val.length);
    }
  },
  methods: {
    upperFirst,
    formatOpeningHours(item) {
      return item[0] === "00:00" && item[1] === "24:00"
        ? this.$t("message.facilityDetails.allDayOpeningHours")
        : item.join(" - ");
    },
    handleDelete() {
      this.$emit("delete", this.item.id);
    },
    handleEdit() {
      this.$emit("edit", { ...this.item });
    }
  }
};
</script>

<style lang="scss" scoped>
.list-item {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  width: 100%;
  padding: 0;

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: $spacing;
    width: 100%;
  }

  &__heading {
    color: $primary;
    margin-bottom: 0;
  }

  &__day {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: $spacing;
  }
}

ul {
  list-style: none;
}
</style>
